import { styled } from '@/styles/stitches.config';
import { countryIdToName } from '@/utils/country-id-to-name';
import { Themes } from '../microstory/theme';
import { Tooltip, TooltipProps } from '../tooltip';
import { Points } from './points';
import { WorldMap } from './svg';

type StoryMapProps = {
  highlightedCountries: CountryIsoCode[];
  theme: Themes;
};

const Root = styled('div', {
  display: 'flex',
  width: '100%',
  height: '100vmin',
  alignSelf: 'flex-end',
});

export function StoryMap(props: StoryMapProps) {
  const { highlightedCountries, theme } = props;

  return (
    <Root>
      <WorldMap theme={theme} css={{ flexGrow: 1 }}>
        <Points
          inStory
          hasThemeColors
          getId={(d) => d.id}
          data={highlightedCountries.map((d) => ({ id: d }))}
          getTooltip={(context) => <StoryMapTooltip {...context} />}
        />
      </WorldMap>
    </Root>
  );
}

type StoryMapTooltipProps = {
  root: TooltipProps['root'];
  data: CountryCoordinate;
};

function StoryMapTooltip(props: StoryMapTooltipProps) {
  const { root, data } = props;

  return (
    <Tooltip
      root={root}
      options={{
        placement: 'top',
        modifiers: [
          { name: 'offset', options: { offset: [0, 12] } },
          { name: 'preventOverflow', options: { mainAxis: true, altAxis: true, padding: 16 } },
        ],
      }}
      css={{
        borderRadius: '$space$3',
        paddingBlock: '$1',
        paddingInline: '$3',
      }}
    >
      {countryIdToName(data.id)}
    </Tooltip>
  );
}
